// extracted by mini-css-extract-plugin
export default {"page-container":"F2Dwi_page-container"};